import React from "react";

const PicnicGameModal = ({
  picnicDisclaimerDataContent,
  disclaimerAcceptedHandler,
  gameDisclaimerAccepted,
}) => {
  const showDisclaimerItemData = (item, ind) => {
    if (item.type === "para") {
      return (
        <div key={ind} className="mb-3">
          <div className="disclaimer-modal-sub-head">{item?.dataHeader}</div>
          {item?.content.length > 0 &&
            item?.content.map((val, i) => (
              <p className="disclaimer-modal-para" key={i}>
                {val}
              </p>
            ))}
        </div>
      );
    } else if (item.type === "link") {
      return (
        <div key={ind} className="mb-3 disclaimer-modal-content-wrapper">
          <div className="disclaimer-modal-sub-head">{item?.dataHeader}</div>
          <div className="disclaimer-modal-links">
            {item?.content.map((val, i) => (
              <a
                key={i}
                href={val.body}
                target="_blank"
                rel="noopener noreferrer"
              >
                {val.head}
              </a>
            ))}
          </div>
        </div>
      );
    } else {
      return null;
    }
  };

  return (
    <div
      className="modal fade disclaimer-modal"
      id="picnicGameModal"
      tabIndex="-1"
      aria-labelledby="picnicGameModalLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-lg modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header"></div>
          <div className="modal-body" tabIndex="0">
            <div className="modal-heading">Picnic Game Disclaimer</div>

            {!gameDisclaimerAccepted ? (
              <>
                {picnicDisclaimerDataContent.length > 0 &&
                  picnicDisclaimerDataContent.map((item, i) =>
                    showDisclaimerItemData(item, i)
                  )}

                <div className="d-flex gap-2">
                  <button
                    type="button"
                    className="btn btn-success"
                    data-bs-dismiss="modal"
                    onClick={disclaimerAcceptedHandler}
                  >
                    Accept
                  </button>
                  <div className="disclaimer-modal-note">
                    By clicking "Accept", you confirm that you've either
                    reviewed the above links or agree to read them later.
                  </div>
                </div>
              </>
            ) : (
              <div className="text-center mt-4">
                <div className="disclaimer-modal-note mb-3">
                  <p>You've already accepted the disclaimer for this game.</p>
                </div>
                <button
                  type="button"
                  className="btn btn-success"
                  data-bs-dismiss="modal"
                  onClick={disclaimerAcceptedHandler}
                >
                  Continue
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PicnicGameModal;
